import React from 'react';
import { Dimmer, Loader, Segment } from 'semantic-ui-react';

type Props = Readonly<{
    cargando: boolean;
}>;

export const SegmentConLoader: React.FC<Props> = props => {
    return (
        <Dimmer.Dimmable as={Segment} dimmed={props.cargando}>
            <Dimmer inverted active={props.cargando}>
                <Loader inverted />
            </Dimmer>

            {props.children}
        </Dimmer.Dimmable>
    );
};



// WEBPACK FOOTER //
// ./src/modulos/Recuperaciones/SegmentConLoader.tsx